var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-button',{attrs:{"route":{ name: 'EntityDetails', params: { id: _vm.entity.id } },"style-classes":("btn-anchor " + _vm.styleClasses),"text":_vm.entity.name,"icon":"building","display-badge":_vm.displayBadge,"badge-offset-x":_vm.badgeOffsetX,"badge-offset-y":_vm.badgeOffsetY,"badge-text":_vm.badgeText}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795c7ffe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/buttons/navigation/EntityButton.vue
// module id = null
// module chunks = 